// extracted by mini-css-extract-plugin
export var assigneeBadge = "_lt-0";
export var assigneeDetails = "_lt-1";
export var assigneeInfo = "_lt-2";
export var dropdownContainer = "_lt-4";
export var dropdownImage = "_lt-5";
export var editAssigneeInfo = "_lt-3";
export var editAssigneeModalContainer = "_lt-6";
export var hidden = "_lt-8";
export var input = "_lt-7";